/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'sync': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M182.717 267.73C258.179 168.266 377.424 103.89 512 103.89c180.188 0 333.1 115.316 389.978 276.04h96.507C938.332 167.588 743.535 11.877 511.977 11.877c-166.504 0-313.68 80.746-405.784 204.868L5.916 149.908v322.013l276.04-138.032-99.24-66.159zm559.305 434.212l99.239 66.182C765.798 867.59 646.554 931.964 512 931.964c-180.21 0-333.077-115.316-389.978-276.04H25.47c60.153 212.342 254.928 368.053 486.507 368.053 166.505 0 313.68-80.745 405.762-204.867l100.3 66.836V563.934L742.022 701.942zm-92.013-322.035H373.99a45.995 45.995 0 100 92.014h276.04a46.04 46.04 0 00-.022-92.014zm0 184.027H373.99a45.995 45.995 0 100 92.013h276.04a45.995 45.995 0 10-.022-92.013z" _fill="#203646"/>'
  }
})
